import React, { useState } from 'react';
import { lessons } from '../../data/palmistry101Content';

export default function PalmistryLessonAccordion({ hasFullAccess = true }) {
  const [openId, setOpenId] = useState(lessons[0]?.id || null);

  return (
    <section
      className="amm-palmistry101-section amm-palmistry101-lessons-section"
      aria-labelledby="palmistry-lessons-heading"
    >
      <h2 id="palmistry-lessons-heading" className="amm-palmistry101-section-title">
        Course Lesson Flow
      </h2>
      <p className="amm-palmistry101-section-intro">
        {hasFullAccess
          ? 'Work through the sequence at your own pace. Each lesson includes short teaching paragraphs, observation prompts, and optional depth.'
          : 'Below is the lesson map for Palmistry 101. Open a lesson for a short preview — the full text opens once you are inside the course.'}
      </p>
      <div className="amm-palmistry101-lesson-list">
        {lessons.map(lesson => {
          const isOpen = lesson.id === openId;
          return (
            <div
              key={lesson.id}
              className={`amm-palmistry101-lesson-card${isOpen ? ' is-open' : ''}`}
            >
              <button
                type="button"
                className="amm-palmistry101-lesson-toggle"
                aria-expanded={isOpen}
                aria-controls={`lesson-panel-${lesson.id}`}
                id={`lesson-${lesson.id}-btn`}
                onClick={() => setOpenId(isOpen ? null : lesson.id)}
              >
                <span className="amm-palmistry101-lesson-title-text">{lesson.title}</span>
                <span className="amm-palmistry101-lesson-chevron" aria-hidden />
              </button>
              <div
                className={`amm-palmistry101-lesson-panel${isOpen ? '' : ' is-collapsed'}`}
                role="region"
                aria-labelledby={`lesson-${lesson.id}-btn`}
                aria-hidden={!isOpen}
                id={`lesson-panel-${lesson.id}`}
              >
                <div className="amm-palmistry101-lesson-inner">
                  <p className="amm-palmistry101-lesson-summary">{lesson.summary}</p>
                  {hasFullAccess ? (
                    <>
                      {lesson.body.map((p, i) => (
                        <p key={i} className="amm-palmistry101-lesson-p">
                          {p}
                        </p>
                      ))}
                      {lesson.prompts && lesson.prompts.length > 0 && (
                        <div className="amm-palmistry101-prompt">
                          <h4 className="amm-palmistry101-prompt-title">Observation prompt</h4>
                          {lesson.prompts.map((p, i) => (
                            <p key={i}>{p}</p>
                          ))}
                        </div>
                      )}
                      {lesson.more && lesson.more.length > 0 && (
                        <details className="amm-palmistry101-more">
                          <summary className="amm-palmistry101-more-summary">Learn more</summary>
                          {lesson.more.map((p, i) => (
                            <p key={i} className="amm-palmistry101-lesson-p">
                              {p}
                            </p>
                          ))}
                        </details>
                      )}
                    </>
                  ) : (
                    <div className="amm-palmistry101-lesson-preview">
                      {lesson.body[0] && (
                        <p className="amm-palmistry101-lesson-p">{lesson.body[0]}</p>
                      )}
                      <p className="amm-palmistry101-lesson-gated">
                        The full lesson opens inside Palmistry 101 once you enroll.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
